// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C8mI","label":"styles_label__3DJ7-"};